import { handleApiPostRequest, handleApiGetRequest } from './utils';

export async function company_positions_list(auth_token, c_id) {
    return await handleApiGetRequest(`permissions/`, {
        action: "company_positions_list",
        userToken: auth_token,
        companyID: c_id,
    });
}

export async function get_all_permissions(auth_token, c_id) {
    return await handleApiGetRequest(`permissions/`, {
        action: "get_all_permissions",
        userToken: auth_token,
        companyID: c_id,
    });
}

export async function get_all_roles(auth_token, c_id) { 
    return await handleApiGetRequest(`permissions/`, {
        action: "get_all_roles",
        userToken: auth_token,
        companyID: c_id,
    });
}

export async function save_new_role(auth_token, c_id, system_role_id, parent_id = 0, custom_role_name = null) {
    return await handleApiPostRequest(`permissions/`, {
        action: "save_new_role",
        userToken: auth_token,
        companyID: c_id,
        custom_role_name: custom_role_name,
        parent_id: parent_id,
        system_role_id: system_role_id
    });
}